import CheckIcon from '@mui/icons-material/Check';
import PhoneIcon from '@mui/icons-material/Phone';
import {
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineSeparator,
} from '@mui/lab';
import { Button, FormHelperText, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import { ChangeSicNumber } from '../Settings/ChangeSicNumber/ChangeSicNumber';
import DisplayPhoneNumber from '../Shared/DisplayPhoneNumber/DisplayPhoneNumber';

interface Props {
    dialerIsEnabled: boolean;
    dialerIsSetup: boolean;
    dialerPhone: string | undefined;
}

export function DialerTimelineItem({ dialerIsEnabled, dialerIsSetup, dialerPhone }: Props) {
    const [showChangeNumber, setShowChangeNumber] = useState(false);

    const handleShowChangeNumber = () => {
        setShowChangeNumber(true);
    };

    return (
        <TimelineItem>
            <TimelineSeparator>
                <TimelineDot color={dialerIsEnabled && dialerIsSetup ? 'success' : undefined}>
                    {!dialerIsSetup ? <PhoneIcon /> : <CheckIcon />}
                </TimelineDot>
                <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ display: 'flex', flexDirection: 'column' }}>
                <Grid container flexDirection="column" spacing={2}>
                    <Grid item>
                        <Typography variant="h5">My StayInContact Number</Typography>
                    </Grid>
                    <Grid item>
                        <Typography color={'text.secondary'}>
                            Completing the setup of your 10-digit phone number in StayInContact is
                            crucial, as it unlocks the full potential of this multi-channel
                            communication tool. By selecting your number now, you gain immediate
                            access to seamless call and SMS capabilities, ensuring you stay
                            connected with your contacts efficiently and reliably. This step is
                            essential in creating a streamlined communication experience, allowing
                            you to engage with others through multiple channels all under one
                            convenient number.
                        </Typography>
                    </Grid>
                    {dialerIsSetup && (
                        <Grid item>
                            <Typography variant="h6">
                                <DisplayPhoneNumber phoneNumber={dialerPhone} />
                            </Typography>
                            <Typography variant="overline">My StayInContact Number</Typography>
                        </Grid>
                    )}
                    {!showChangeNumber && !dialerIsSetup && (
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleShowChangeNumber}
                                disabled={!dialerIsEnabled || dialerIsSetup}
                            >
                                Setup My StayInContact Number
                            </Button>
                            {!dialerIsSetup && (
                                <FormHelperText>
                                    This package is not active for your account.
                                </FormHelperText>
                            )}
                        </Grid>
                    )}
                    {showChangeNumber && (
                        <Grid item>
                            <ChangeSicNumber />
                        </Grid>
                    )}
                </Grid>
            </TimelineContent>
        </TimelineItem>
    );
}
